export default {
  ERROR_404: 'https://oss.zhihanyun.com/1591324417158_404.png?imageslim'
}
